import CropTypeManager from './CropTypeManager';
export default CropTypeManager;
